import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { api, errorMessage } from '../../api/client';

export function LogsPanel({ machineId }: { machineId: string }) {
  const [which, setWhich] = useState<'comfyui' | 'agent' | null>(null);
  const logs = useQuery({ queryKey: ['logs', machineId, which], queryFn: () => api.machineLogs(machineId, which ?? 'comfyui'), enabled: which !== null, retry: false });
  return (
    <section className="panel" aria-labelledby="logs-title">
      <h2 id="logs-title">Logs</h2>
      <div className="machine-actions">
        <button type="button" className="button-quiet" onClick={() => { setWhich('comfyui'); }}>Show ComfyUI log</button>
        <button type="button" className="button-quiet" onClick={() => { setWhich('agent'); }}>Show agent log</button>
      </div>
      {logs.isError && <p role="alert" className="form-error">{errorMessage(logs.error)}</p>}
      {logs.data && <pre className="log">{logs.data.lines.join('\n')}</pre>}
    </section>
  );
}
